import script from "./BlueBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlueBtn.vue?vue&type=script&lang=ts&setup=true"

import "./BlueBtn.vue?vue&type=style&index=0&id=2b66b90c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b66b90c"]])

export default __exports__